class VariantStickyPrice extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		document.forms[this.getAttribute('form')].addEventListener('product:rerender', (event) => {
			this.updatePrice(event);
		});
	}

	disconnectedCallback() {
		document.forms[this.getAttribute('form')].removeEventListener('product:rerender', this.updatePrice);
	}

	updatePrice(event) {
		const matchingElement = event.detail.htmlFragment.querySelector(`[data-block-type="price"][data-block-id="price"]`);
		const priceElement = matchingElement.querySelector(`price-list`);
		if (priceElement) {
			const oldPrice = this.firstChild?.lastElementChild;
			const newPrice = priceElement.cloneNode(true);
			if (oldPrice) {
				oldPrice.replaceWith(newPrice);
			} else if (this.firstChild) {
				this.firstChild.appendChild(newPrice);
			} else {
				this.appendChild(newPrice);
			}
		}
	}
}

if (!window.customElements.get('variant-sticky-price')) {
	window.customElements.define('variant-sticky-price', VariantStickyPrice);
}
